/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from '@reduxjs/toolkit';

import {
	commonReducers,
	CommonState,
	initialCommonState,
} from '../_common/commonReducers';

export type AuditItem = Record<string, any>;

interface AuditState extends CommonState {}

const initialState: AuditState = {
	...initialCommonState,
};

const auditSlice = createSlice({
	name: 'audit',
	initialState,
	reducers: commonReducers,
});

export const {
	getTableStart,
	getTableSuccess,
	getTableFailure,
	getTableFinish,

	getItemStart,
	getItemSuccess,
	getItemFailure,
	getItemFinish,

	createItemStart,
	createItemSuccess,
	createItemFailure,
	createItemFinish,

	updateItemStart,
	updateItemSuccess,
	updateItemFailure,
	updateItemFinish,

	deleteItemsStart,
	deleteItemsSuccess,
	deleteItemsFailure,
	deleteItemsFinish,

	deleteItemStart,
	deleteItemSuccess,
	deleteItemFailure,
	deleteItemFinish,

	getTableStructureStart,
	getTableStructureSuccess,
	getTableStructureFailure,

	getItemDocumentsStart,
	getItemDocumentsSuccess,
	getItemDocumentsFailure,
	getItemDocumentsFinish,

	uploadItemDocumentsStart,
	uploadItemDocumentsSuccess,
	uploadItemDocumentsFailure,
	uploadItemDocumentsFinish,

	deleteItemDocumentStart,
	deleteItemDocumentSuccess,
	deleteItemDocumentFailure,
	deleteItemDocumentFinish,

	getTableExcelStart,
	getTableExcelSuccess,
	getTableExcelFailure,
	getTableExcelFinish,
} = auditSlice.actions;

export default auditSlice;
